import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const KrebsvorsorgePage = () => {
  return (
    <Layout>
      <PageHero
        title="Krebsvorsorge (Männer): Früherkennung ab dem 45. Lebensjahr"
        subtitle="Wir unterstützen Männer aktiv bei der Früherkennung von Krebs."
        backgroundImage="/images/Krebsvorsorge_Maenner2.webp"
        ctaText="Krebsvorsorge-Termin buchen"
      />

      <ContentSection
        title="Gemeinsam Krebsrisiken minimieren"
        content="Ab dem 45. Lebensjahr haben Männer Anspruch auf regelmäßige Vorsorgeuntersuchungen zur Früherkennung von Krebserkrankungen, insbesondere Prostatakrebs und Darmkrebs. Wir beraten Sie umfassend, führen die notwendigen Untersuchungen durch und klären Sie über die Wichtigkeit der Früherkennung auf."
        image="/images/Krebsvorsorge_Maenner1.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Männliche Krebsvorsorge in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet spezialisierte Krebsvorsorgeuntersuchungen für Männer an, um Risiken frühzeitig zu erkennen."
      />

      <CTASection
        title="Nehmen Sie Ihre Gesundheit selbst in die Hand"
        subtitle="Vereinbaren Sie einen Termin für Ihre Krebsvorsorge."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default KrebsvorsorgePage;
